<template>
  <div>
    <div class="col-12 bg-white p-4 float-left single-form-results-view">
      <b-row class="pb-3 print_hide" style="display: inline-block;width: 100%;">
        <b-link class="print_hide" :append="true"
                v-on:click="$emit('update:formsResultsView', true)"><i class="fa fa-chevron-left"></i> {{$t('Back to Results') }}
        </b-link>
<!--        <b-btn class="print_hide" v-show="massReportRows.length > 0" style="float:right;color:white;margin-bottom: 10px;margin-top: 10px;margin-right: 10px" variant="light" @click="printFormResults()"><i class="fa fa-print"></i> {{$t('Print Results')}}</b-btn>-->
      </b-row>
      <b-row>
        <b-col lg="8" class="my-1 print_hide">
          <h4 class="pl-2 pb-2 ">
            {{formResult.formName}}
            <span class="d-inline" v-if="formResult.hasOwnProperty('tag') && formResult.tag != null">({{formResult.tag}})</span>

          </h4>
        </b-col>
        <!--<b-col class="text-right pr-4 print_hide">-->
        <!--<span>{{reportDate}}</span>-->
        <!--</b-col>-->
      </b-row>
<!--      <template v-for="(reportRows, ind) in massReportRows">-->
        <table class="table table-bordered mb-5">
          <thead style="background-color: #e9f4f9;border: 2px solid #c8e9f8;">
          <th style="width: 170px;">User</th>
          <th style="width: 120px;">Time</th>
          <th  style="width: 250px;">Name</th>
          <th>Result</th>
<!--          <th>Actions</th>-->
          </thead>
          <tbody style="border: 2px solid #c8e9f8;">
          <template v-for="(row, rowIndex) in formResult.resultsArray">
          <tr v-if="!(formResult.onlyFilledFields && row.type !== 'NOTE' && row.value === null)" :class='row.type === "note" ? "style=border-top: 2px solid rgb(200, 233, 248);" : ""' v-bind:key="rowIndex" >
            <template v-if="row.type === 'NOTE'">
              <th colspan="5" ><div style="white-space: pre-wrap;" v-html="row.name"></div></th>
            </template>
            <template v-else>
              <td>{{row.displayName ? row.displayName : ""}}</td>
              <td>{{row.recordedAtFormatted}}</td>
              <td>{{row.name}}</td>
              <td v-html="row.hasOwnProperty('valueLabel') ? row.valueLabel : row.value">{{row.hasOwnProperty("valueLabel") ? row.valueLabel : row.value}}</td>
<!--              <td>-->
<!--                <b-button variant="outline-primary" size="sm" @click="print('')" class="mr-1">-->
<!--                  {{$t('Edit')}}-->
<!--                </b-button>-->
<!--              </td>-->
            </template>
          </tr>
          </template>
<!--          <template v-for="(row, rowIndex) in reportRows.data">-->
<!--            <template v-if="row.results.length > 0">-->
<!--              <template v-for="(result,indexx) in row.results">-->
<!--                &lt;!&ndash;<template v-if="result.order === row.order">&ndash;&gt;-->
<!--                <tr :style="indexx === 0? '    border-top: 2px solid rgb(200, 233, 248);' : ''" v-bind:key="indexx+ind+'-'+rowIndex">-->
<!--                  <td v-bind:key="result.userId+ind+indexx">-->
<!--                    <span style="margin-right: 5px;float: left;">{{indexx+1}}</span>-->
<!--                    <b-link  class="nav-link no-padding print_hide" :to="'/users/'+result.userId"> {{result.userName}} </b-link>-->
<!--                    <div class="print_show">{{result.userName}}</div>-->
<!--                  </td>-->
<!--                  <td v-bind:key="result.recordedAt+ind+indexx">{{result.recordedAt}}</td>-->
<!--                  <th :rowspan="row.results.length"  v-bind:key="result.name+ind+indexx" v-if="indexx === 0" >{{row.name}}</th>-->
<!--                  <td v-html="result.value" v-bind:key="result.value+ind+indexx">{{result.value}}</td>-->
<!--                </tr>-->
<!--                &lt;!&ndash;</template>&ndash;&gt;-->
<!--                &lt;!&ndash;<template v-else>&ndash;&gt;-->
<!--                &lt;!&ndash;<td v-bind:key="result" colspan="3">empty?</td>&ndash;&gt;-->
<!--                &lt;!&ndash;</template>&ndash;&gt;-->
<!--              </template>-->
<!--            </template>-->
<!--            <template v-else>-->
<!--              <tr style="border-top: 2px solid rgb(200, 233, 248);" v-bind:key="rowIndex">-->
<!--                <th v-if="row.type !== 'NOTE'"></th>-->
<!--                <th v-if="row.type !== 'NOTE'"></th>-->
<!--                <th :colspan="row.type === 'NOTE'? 4 : 1" ><div style="white-space: pre-wrap;" v-html="row.name"></div></th>-->
<!--                <template v-if="row.type !== 'NOTE'">-->
<!--                  <td ></td>-->
<!--                </template>-->

<!--              </tr>-->
<!--            </template>-->
<!--          </template>-->
          </tbody>
        </table>
<!--      </template>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormResult',
  props: {
    'formResult': {
      default: {},
      type: Object
    },
    'formsResultsView': {
      default: false,
      type: Boolean
    }
  },
  methods: {
    updateFormSubmission () {

    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/OperationForms/FormResult.vue